export const invoiceAdd =
{
    path: "/invoiceAdd",
    component: () => import("@/views/invoiceLottery/invoiceAdd.vue"),
    meta: {
        hidden: true,
    },
}
export const invoiceSelect =
{
    path: "/invoiceSelect",
    component: () => import("@/views/invoiceLottery/invoiceSelect.vue"),
    meta: {
        hidden: true,
    },
}